import { DatePeriod } from 'types/mediaplan';

export function convertToDatePeriod({ startDate, endDate }: DatePeriod): Date[] {
  return [new Date(startDate), new Date(endDate)];
}
